import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import Header from "./components/header/Header";
import CandidateRegister from "./pages/auth/CandidateRegister";
import VoterRegister from "./pages/auth/VoterRegister";
import Login from "./pages/auth/Login";
import Candidate from "./pages/Candidate";
import { Categories } from "./pages/Categories";
import Footer from "./components/footer/Footer";
import CategoryMembers from "./pages/CategoryMembers";
import VoterDashboard from "./pages/VoterDashboard";
import CandidateDashboard from "./pages/CandidateDashboard";
import Help from "./pages/Help";
import VoterResetPass from "./pages/auth/VoterReset";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CandidateResetPass from "./pages/auth/CandidateReset";
import WhatsAppButton from "./components/WhatsAppButton";
import UpdateCandidate from "./pages/UpdateCandidate";
import Contact from "./pages/Contact";
import PublicResultPage from "./pages/PublicResultsPage";
import ScrollToTop from "./utils/ScrollToTop";
import Maintenance from "./pages/Maintenance";
function App() {
  return (
    <BrowserRouter>
      <Header />
      <ScrollToTop />
      <WhatsAppButton />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<Maintenance />} />
        {/* <Route path="/contact-us" element={<Contact />} />
        <Route path="/public-result" element={<PublicResultPage />} />
        <Route path="/candidate/register" element={<CandidateRegister />} />
        <Route path="/candidate/update" element={<UpdateCandidate />} />
        <Route path="/voter/register" element={<VoterRegister />} />
        <Route path="/login" element={<Login />} />
        <Route path="/help" element={<Help />} />
        <Route path="/candidates" element={<Candidate />} />
        <Route path="/reset-voter-pass" element={<VoterResetPass />} />
        <Route path="/reset-candidate-pass" element={<CandidateResetPass />} />
        <Route path="/vote" element={<Categories />} />
        <Route path="/category/:slug" element={<CategoryMembers />} />
        <Route path="/candidate/dashboard" element={<CandidateDashboard />} />
        <Route path="/voter/dashboard" element={<VoterDashboard />} /> */}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
